import React, { useContext, useState, useEffect, useRef } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { Formik, Field } from "formik";
import {
  faPencilAlt,
  faTimes,
  faTrashAlt,
} from "@fortawesome/pro-light-svg-icons";
import { ExcludedEmployeeClassficationFields } from "./ExcludedEmployeeClassification";
import { WindowPeriodFields } from "./WindowPeriod";
import { DeferralElection } from "./DeferralElection";
import _, { isEmpty, get, indexOf, uniqBy } from "lodash";
import {
  FieldButtonGroup,
  LoaderWrapper,
  AddPlans,
  CsplTable as Table,
  Link,
  FieldInputNumber,
} from "../../../components";
import {
  FLOW_TYPES,
  MANAGE_PLAN_ROUTES,
  getPathWithParam,
  managePlanFormNames,
  formFields,
  yesNoOptions,
  toOptionValuesFromMapper,
  OPTIONS_DATA_MAPPER,
  returnOnlyIfBoolean,
  ENROLLMENT_DROPDOWN_OPTIONS,
  INVESTMENTS_BASED_ON,
  getAdvancedPathWithParam,
  clearFieldValues,
} from "../../../utils";
import {
  createPlanStore,
  setManagePageLevelData,
  setManagePlanLocalCache,
  setManagePlanToastInfo,
  clearLocalCacheByModel,
} from "../../../contexts";
import {
  useRouterParams,
  useRequest,
  useTableChecboxSelect,
  useDeepEffect,
} from "../../../abstracts";
import {
  getPlanSourceInformation,
  getAutoEnrollment,
  getPlanInvestments,
  getAdditionalAutoEnrollment,
} from "../../../services";
import InvestmentElectionFields from "./InvestmentElection";
import CompensationTableRow from "../../../components/CompensationTable/CompensationTableRow";
import { trueFalseOptions } from "../../ReportsContainer/PeriodicCensus/columnMenu";

//const formName = managePlanFormNames.ADD_AUTO_ENROLLMENT;
//const fields = formFields[formName];

const columns = [
  {
    label: "Enrollment Description",
    className: "column-addtional-Enrollment-description",
    columnName: "enrollmentDescription",
  },
  {
    label: "Action",
    className: "column-action",
    columnName: "action",
    link: MANAGE_PLAN_ROUTES.ADDITIONAL_AUTO_ENROLLMENT,
  },
];

export const AutoEnrollment = (props) => {
  const {
    history,
    getDefaultElection,
    setToggle,
    planId,
    isEdit,
    isSave,
    toggle,
    errorMessages,
    //form props
    setFieldValue,
    values,
    fields,
    handleChange,
    handleSubmit,
    setValues,
    setSubmitting,
    sourcesList,
    transformedEmployeeDeferralSourceList,
    investmentList,
  } = props;
  const { state, dispatch } = useContext(createPlanStore);
  const { flow, fundId } = useRouterParams();
  const [newFlow, setNewFlow] = useState(fundId ? FLOW_TYPES.EDIT : "");
  const getDefaultElectionNew = {
    planInvestment: get(values, "planInvestment", []),
    deferralSourceContribution: get(values, "deferralSourceContributions", []),
  };
  // !isEmpty(getDefaultElection)
  //   ? getDefaultElection
  //   :

  //const [autoEnrollment, setAutoEnrollment] = useState({});
  const [inputFields, setInputFields] = useState([
    { from: "", to: "", subjecttoAutoEnrollment: "N" },
  ]);
  const autoEnrollment =
    get(values, "autoEnrollment", {}) === null
      ? {}
      : get(values, "autoEnrollment", {});

  const additionalEnrollmentRules = isEmpty(
    get(state, "AdditionalAutoEnrollment", [])
  )
    ? get(autoEnrollment, "additionalAutoEnrollment", [])
    : get(state, "AdditionalAutoEnrollment", []);

  // useDeepEffect(() => {
  //   dispatch(
  //     setManagePlanLocalCache({
  //       model: "AdditionalAutoEnrollment",
  //       data: uniq,
  //     })
  //   );
  //   //}
  // }, [AdditionalAutoEnrollment]);

  const [DateFields, setDateFields] = useState([{ from: "", to: "" }]);
  const [investmentListedit, setinvestmentListedit] = useState([]);

  // useDeepEffect(() => {
  //   getAutoEnrollment(planId).then((response) => setAutoEnrollment(response));
  // }, [isEdit]);

  // getInitialValues(autoEnrollment, investmentList, sourcesList)
  const clearCache = () => {
    dispatch(clearLocalCacheByModel("AutoEnrollment"));
  };
  useDeepEffect(() => {
    if (values.isDirty == true) setFieldValue("autoEnrollment.isDirty", true);
  }, [values.isDirty]);

  const goBack = () => {
    history.push(
      getPathWithParam({
        path: MANAGE_PLAN_ROUTES.MANAGE_FUNDING,
        pathParam: planId,
      })
    );
  };
  const onDeleteClick = () => {
    goBack();
  };

  // formik functions
  const onDaySelected = (fieldName, value) => {
    setFieldValue(fieldName, value);
  };

  // setinvestmentListedit(investmentList); //bookmark

  const addAdditionalEnrollmentClick = () => {
    setSubmitting(true);
    const additionalEnrollmentId = (additionalEnrollmentRules || []).length;
    dispatch(
      setManagePlanLocalCache({
        model: "AutoEnrollment",
        data: values,
      })
    );
    window.setTimeout(() => {
      history.push(
        getAdvancedPathWithParam({
          path: MANAGE_PLAN_ROUTES.ADDITIONAL_AUTO_ENROLLMENT,
          pathParam: [FLOW_TYPES.ADD, planId],
          queryParam: ["/0/" + additionalEnrollmentId],
        })
      );
    }, 10);
  };

  const editAdditionalEnrollmentRuleClick = (id, index) => {
    dispatch(
      setManagePlanLocalCache({
        model: "AutoEnrollment",
        data: values,
      })
    );
    setSubmitting(true);
    window.setTimeout(() => {
      history.push(
        getPathWithParam({
          path: MANAGE_PLAN_ROUTES.ADDITIONAL_AUTO_ENROLLMENT,
          pathParam: [FLOW_TYPES.EDIT, planId],
          queryParam: [`/${id}/${index}`],
        })
      );
    }, 10);
  };

  return (
    <div>
      <Row>
        {" "}
        <Col>
          {" "}
          <div className="plan-sub-heading mt-0"></div>{" "}
        </Col>
      </Row>
      <Row>
        {" "}
        <Col>
          {" "}
          <div className="plan-sub-heading mt-0">Auto Enrollment</div>{" "}
        </Col>
      </Row>
      <Row>
        <Col>
          <Field
            isRequired
            name={`autoEnrollment.${fields.subjecttoAutoEnrollment}`}
            label="Subject to Auto-Enrollment"
            size="sm"
            options={yesNoOptions}
            selectedValue={get(
              values,
              `autoEnrollment.${fields.subjecttoAutoEnrollment}`,
              false
            )}
            onChange={(value) => {
              setValues({
                ...values,
                autoEnrollment: {
                  [fields.isWindowPeriod]: value === true ? true : null,
                  [fields.usePlanDefaultDeferralElection]:
                    value === true ? true : null,
                  [fields.subjecttoAutoEnrollment]: value,
                  [fields.isAutoReEnroll]:
                    value === get(values.autoEnrollment, fields.isAutoReEnroll),
                  // [fields.frequencyOptoutIndicator]: 1,
                  [fields.exclusionType]: value === true ? 0 : null,
                  [fields.usePlanDefaultInvestmentElection]:
                    value === true ? true : null,
                },
              });
              // setFieldValue(
              //   `autoEnrollment.${fields.subjecttoAutoEnrollment}`,
              //   value
              // );
            }}
            disabled={isEdit && !isSave}
            value={get(values.autoEnrollment, fields.subjecttoAutoEnrollment)}
            component={FieldButtonGroup}
          />
          {get(values, `autoEnrollment.${fields.subjecttoAutoEnrollment}`) ===
          true ? (
            <>
              {/* <Field
                label="Minimum withdrawal limit"
                name={`autoEnrollment.${fields.minimumWithdrawallimit}`}
                options={toOptionValuesFromMapper(
                  OPTIONS_DATA_MAPPER.MINIMUM_WITHDRAWAL_LIMIT
                )}
                component={FieldButtonGroup}
                selectedValue={get(
                  values,
                  `autoEnrollment.${fields.minimumWithdrawallimit}`
                )}
                onChange={(value) => {
                  setFieldValue(
                    `autoEnrollment.${fields.minimumWithdrawallimit}`,
                    value
                  );
                }}
                disabled={isEdit && !isSave}
                size="smd"
              /> */}

              <p className="font-weight-500 text-black"> Window Period</p>
              <div>
                <WindowPeriodFields
                  {...props}
                  fields={fields}
                  isEdit={isEdit}
                  isSave={isSave}
                  autoEnrollment={autoEnrollment}
                />
              </div>

              <Field
                isRequired
                name={`autoEnrollment.${fields.isAutoReEnroll}`}
                label="Auto re-enroll"
                size="sm"
                options={yesNoOptions}
                selectedValue={returnOnlyIfBoolean(
                  get(values, `autoEnrollment.${fields.isAutoReEnroll}`)
                )}
                onChange={(value) => {
                  setFieldValue(
                    `autoEnrollment.${fields.isAutoReEnroll}`,
                    value
                  );
                  if (value === true) {
                    setFieldValue(
                      `autoEnrollment.${fields.frequencyOptoutIndicator}`,
                      null
                    );
                    setFieldValue(
                      `autoEnrollment.${fields.numberOfDaysWindowIsOpenReEnrollmentNumber}`,
                      null
                    );
                  }
                }}
                disabled={isEdit && !isSave}
                component={FieldButtonGroup}
              />
              {get(values, `autoEnrollment.${fields.isAutoReEnroll}`) ===
              true ? (
                <>
                  <Field
                    label="Optout Reset Frequency"
                    name={`autoEnrollment.${fields.frequencyOptoutIndicator}`}
                    options={toOptionValuesFromMapper(
                      OPTIONS_DATA_MAPPER.OPTOUT_RESET_FREQUENCY
                    )}
                    component={FieldButtonGroup}
                    selectedValue={get(
                      values,
                      `autoEnrollment.${fields.frequencyOptoutIndicator}`
                    )}
                    onChange={(value) => {
                      setFieldValue(
                        `autoEnrollment.${fields.frequencyOptoutIndicator}`,
                        value
                      );
                    }}
                    disabled={isEdit && !isSave}
                    isRequired
                    size="smd"
                  />

                  <p className="font-weight-500 text-black">
                    Window Period for Re-enrollment
                  </p>
                  <div className="d-flex">
                    <Field
                      size="sm"
                      name={`autoEnrollment.${fields.numberOfDaysWindowIsOpenReEnrollmentNumber}`}
                      label={
                        "Number Of Days Window Is Open for re-enrollment after optout reset"
                      }
                      type="number"
                      autoComplete="off"
                      value={get(
                        values.autoEnrollment,
                        fields.numberOfDaysWindowIsOpenReEnrollmentNumber
                      )}
                      onChange={handleChange}
                      disabled={isEdit && !isSave}
                      component={FieldInputNumber}
                      min={1}
                      max={999}
                      isRequired
                    />
                  </div>
                </>
              ) : null}
              {/* <p className="font-weight-500 text-black"> Window Period</p>
              <div>
                <WindowPeriodFields
                  {...props}
                  fields={fields={isSave}
                  autoEnrollment={autoEnrollment}
                />
              </div> */}

              <p className="font-weight-500 text-black">Exclusions</p>
              <div>
                <ExcludedEmployeeClassficationFields
                  {...props}
                  fields={fields}
                  isEdit={isEdit}
                  isSave={isSave}
                  autoEnrollment={autoEnrollment}
                  //employeeClassification={employeeClassification}
                  planId={planId}
                />
              </div>

              <div></div>
              <p className="font-weight-500 text-black">Deferral Election</p>
              <div>
                <DeferralElection
                  {...props}
                  fields={fields}
                  isEdit={isEdit}
                  isSave={isSave}
                  sourcesList={transformedEmployeeDeferralSourceList}
                  getDefaultElection={getDefaultElectionNew}
                  autoEnrollment={autoEnrollment}
                />
              </div>

              <p className="font-weight-500 text-black">Investment Election</p>
              <div>
                <InvestmentElectionFields
                  {...props}
                  fields={fields}
                  isEdit={isEdit}
                  isSave={isSave}
                  sourcesList={sourcesList}
                  investmentList={investmentList}
                  getDefaultElection={getDefaultElectionNew}
                  setToggle={setToggle}
                  autoEnrollment={autoEnrollment}
                  planId={planId}
                />
              </div>

              {!isEmpty(additionalEnrollmentRules) ? (
                <div>
                  <div className="d-flex justify-content-between bg-title">
                    <p
                      className="font-weight-500 text-black"
                      style={{ paddingRight: "40px" }}
                    >
                      Additional Auto Enrollment Rules
                    </p>
                    <div className="add-rules-button">
                      <Link disabled={isEdit && !isSave}>
                        <Button
                          disabled={isEdit && !isSave}
                          variant="secondary"
                          onClick={addAdditionalEnrollmentClick}
                        >
                          Add Rules
                        </Button>
                      </Link>
                    </div>
                  </div>
                  <div>
                    <Table className="additional-enrollment-table">
                      <Table.Thead>
                        <Table.Tr>
                          {columns.map((item, index) => {
                            return (
                              <Table.Th key={index} className={item.className}>
                                {item.label}
                              </Table.Th>
                            );
                          })}
                        </Table.Tr>
                      </Table.Thead>
                      <Table.Tbody>
                        {additionalEnrollmentRules &&
                          additionalEnrollmentRules.map(
                            (additionalEnrollment, index) => {
                              return (
                                <Table.Tr key={index}>
                                  {columns.map((item, cellIndex) => {
                                    const getContent = () => {
                                      if (item.link) {
                                        return (
                                          <Link
                                            onClick={() => {
                                              editAdditionalEnrollmentRuleClick(
                                                //item,
                                                get(
                                                  additionalEnrollmentRules[
                                                    index
                                                  ],
                                                  "id",
                                                  0
                                                ),
                                                index
                                              );
                                            }}
                                          >
                                            View
                                          </Link>
                                        );
                                      }
                                      return additionalEnrollment[
                                        item.columnName
                                      ];
                                    };

                                    return (
                                      <Table.Td
                                        key={cellIndex}
                                        className={item.className}
                                      >
                                        {getContent()}
                                      </Table.Td>
                                    );
                                  })}
                                </Table.Tr>
                              );
                            }
                          )}
                      </Table.Tbody>
                    </Table>
                  </div>
                </div>
              ) : (
                <div>
                  <LoaderWrapper>
                    <AddPlans
                      content={<>Additional Auto Enrollment Rules.</>}
                      buttonLabel="Add Enrollment Rules"
                      onPrimaryClick={addAdditionalEnrollmentClick}
                      disabled={isEdit && !isSave}
                    />
                  </LoaderWrapper>
                </div>
              )}
            </>
          ) : null}
        </Col>
      </Row>
    </div>
  );
};
